<div class="loading-modal" >
  <div class="box-modal">
    <div class="spinner"></div>
    <div class="box-text">
      <h1>{{ title }}</h1>
      <span>{{ subTitle }}</span>
    </div>
  </div>
</div>
